import styled, { css } from 'styled-components';
import { CIRCUMFERENCE } from './constants';
import { SvgProps, CircleValueProps } from './types';
import { withStyles, LinearProgress, color } from '@kis-technologies/kis-ui';

const size = (props: SvgProps) =>
  props.size &&
  css`
    width: ${props.size}px;
    height: ${props.size}px;
  `;

export const Svg = styled.svg.attrs({
  viewBox: '0 0 200 200'
})<SvgProps>`
  ${size};
`;

const circleStyles = css`
  cx: 100;
  cy: 100;
  r: 75;
  fill: none;
  transform-origin: center;
  transform: rotate(100deg);
  stroke-width: 38;
`;

export const CircleWhole = styled.circle`
  ${circleStyles};
  stroke: #cfcfcf;
`;

export const CircleValue = styled.circle<CircleValueProps>`
  ${circleStyles};
  stroke-linecap: round;
  transition: all 1.1s linear;

  ${(props) =>
    props.dashoffset &&
    css`
      stroke-dashoffset: ${props.dashoffset};
      stroke-dasharray: ${CIRCUMFERENCE};
    `};

  ${(props) =>
    props.strokeColor &&
    css`
      stroke: ${props.strokeColor};
    `}
`;

export const SvgText = styled.text.attrs({
  dy: '.3em'
})`
  transform: translate(50%, 50%);
  text-anchor: middle;
  fill: ${color.BLACK};
  font-size: 26px;
  font-weight: 600;
`;

export const PrintingLinearProgress = withStyles(() => ({
  root: {
    height: '25px',
    width: '70%'
  },
  colorPrimary: {
    backgroundColor: 'rgb(255, 212, 0)',
    border: '5px solid #003a54'
  },
  barColorPrimary: {
    backgroundColor: '#003a54'
  }
}))(LinearProgress);
